import React from 'react'; 
import ReactDOM from 'react-dom/client';
import { bible_init} from "./bible/bible.js";
import {book_output} from "./bible/book.js";
import {chapter} from "./bible/chapter.js";
import {verse} from "./bible/verse.js";
import {verse_selected} from "./bible/verse-selected.js";

import { Select, Option } from "@material-tailwind/react";
import './BibleText.css'; 

export class BibleText extends React.Component {
constructor(props){
  super(props );
 this.state = {
      options: [

      ],
      bookoptions:[
        ],  chapter:[
        ],  verse:[
        ],selectedValue: "",isListenerAttached: false
    };

}

setisListenerAttached = (newValue) => {
    this.setState({ isListenerAttached: false });
  };

componentDidMount() {
var Bookversion;
var newOption; 
bible_init()
  .then((promiseResult) => {
    Bookversion = promiseResult;
    // Continue with further code that depends on `Bookversion`
    console.log(Bookversion);
newOption = Bookversion.map((version) => (
{
  id: version.id,
  value: version.value,
  label: version.text,
}));

    console.log(newOption);

    this.setState((prevState) => ({
      options: [...prevState.options, ...newOption],
    }));

  })
  .catch((error) => {
    console.error("An error occurred:", error);
  });

  }




  setValue = (newValue) => {
  
  console.log(newValue + "what is this");
  };

 handleChange=(e)=>{
   // setTemp(e);
  const parts = e.split("_");
  const value = parts[0];
  const id = parts[1];
  const name = parts[2];

  console.log(id);
  console.log(value);
  var Bookversion;
var newOption; 
book_output(id,value).then((promiseResult) => {
    Bookversion = promiseResult;
    // Continue with further code that depends on `Bookversion`
   this.setState((prevState) => ({
      bookoptions: [],
    }));

newOption = Bookversion.map((version) => (
{
  id: version.id,
  value: version.value,
  label: version.text,
}));


  console.log(newOption);
   this.setState((prevState) => ({
      bookoptions: [...prevState.bookoptions, ...newOption],
    }));
  })
  .catch((error) => {
    console.error("An error occurred:", error);
  });

 }

handleChangechapter=(e)=>{
   // setTemp(e);
  const parts = e.split("_");
  
  const value = parts[0];
  const id = parts[1];
  const name = parts[2];
  document.getElementById("book_type").innerHTML = name;
  console.log(id);
  console.log(value);
  var Bookversion;
var newOption; 
chapter(id,value).then((promiseResult) => {
    Bookversion = promiseResult;
    // Continue with further code that depends on `Bookversion`
   this.setState((prevState) => ({
      chapter: [],
    }));

newOption = Bookversion.map((version) => (
{
  id: version.id,
  value: version.value,
  label: version.text,
}));

  console.log(newOption);
   this.setState((prevState) => ({
      chapter: [...prevState.chapter, ...newOption],
    }));
  })
  .catch((error) => {
    console.error("An error occurred:", error);
  });

 }


handleChangeverse=(e)=>{
   // setTemp(e);
  const parts = e.split("_");
  const value = parts[0];
  const id = parts[1];
  const name = parts[2];
  document.getElementById("chapter_type").innerHTML = name;
  console.log(id);
  console.log(value);
  var Bookversion;
var newOption; 
verse(id,value).then((promiseResult) => {
    Bookversion = promiseResult;
    // Continue with further code that depends on `Bookversion`
   this.setState((prevState) => ({
      verse: [],
    }));

newOption = Bookversion.map((version) => (
{
  id: version.id,
  value: version.value,
  label: version.text,
}));

  
  console.log(newOption);
   this.setState((prevState) => ({
      verse: [...prevState.verse, ...newOption],
    }));
  })
  .catch((error) => {
    console.error("An error occurred:", error);
  });

 }


handleChangeverseSelected=(e)=>{
   // setTemp(e);
  const parts = e.split("_");
  const value = parts[0];
  const id = parts[1];
  const name = parts[2];
  document.getElementById("verse_type").innerHTML = name;
  console.log(id);
  console.log(value);
  var Bookversion;
  var newOption; 
  verse_selected(id,value).then((promiseResult) => {

  })
  .catch((error) => {
    console.error("An error occurred:", error);
  });

 }


 nextbutton(){
    console.log(document.getElementById("verse_text").innerHTML);
  document.getElementById("i_bibleVerse").innerHTML =  document.getElementById("verse_text").innerHTML;
  document.getElementById("black_container").style.display = "none";
 }

render(){

   const { options } = this.state;
   const {bookoptions} = this.state;
   const {chapter} = this.state;
   const {verse} = this.state;
	return(
<div className="w-[800px] flex items-center justify-center h-96"> 
<div className="dropdown dropdown-bottom flex">
<div className="w-72">
<p className="mb-3 text-white dark:text-gray-400 text-xs absolute ">Choose Your Bible Verse</p>
<div className="mt-6 mb-2">
     <Select label="Select Bible" id="bible_type" className="text-white text-xs" onChange={this.handleChange} >
       {this.state.options.map((option) => (
            <Option   label={option.id} value={option.value+"_"+option.id} id="bible" name={option.label} >
              {option.label}
            </Option>
          ))}
      </Select>
  }
</div>
<div className="Select_book mb-2">
       <Select label="Select Book" id="book_type" className="text-white" onChange={this.handleChangechapter}>
           
           {this.state.bookoptions.map((option) => (
            <Option  value={option.value + "_" +option.id+"_"+option.label} id={option.id} label={option.id} name={option.label} >
              {option.label}
            </Option>
          ))}
      </Select>
 }
</div>
<div className="mb-2">
       <Select label="Select Chapter" id="chapter_type" className="text-white" onChange={this.handleChangeverse} >
     {this.state.chapter.map((bookoptions) => (
            <Option  value={bookoptions.value + "_" +bookoptions.id + "_" + bookoptions.label} id={bookoptions.id} label={bookoptions.id} >
              {bookoptions.label}
            </Option>
          ))}
      </Select>
</div>
<div className="mt-6">
       <Select label="Select Verse" id="verse_type" className="text-white" onChange={this.handleChangeverseSelected} >
      {this.state.verse.map((bookoptions) => (
            <Option  value={bookoptions.value + "_" +bookoptions.id + "_" + bookoptions.label} id={bookoptions.id} label={bookoptions.id} >
              {bookoptions.label}
            </Option>
          ))}
      </Select>
      </div>
</div>
<div class="items-center justify-center pl-10 h-inherit w-inherit z-10">
  <div id="verse_text" className="flex items-center justify-center h-4/5"><p className="text-gray-100">'John 3:16 For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.'</p></div>
     <div class="flex justify-end items-end h-1/5">
   <button class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded" onClick={this.nextbutton}>
Next
</button>
</div>
</div>
</div>
</div>
		);
}

}